// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"456":"5f634dde","828":"ea170da7"}[chunkId] + ".chunk.js";
};